// @TODO Update this to use a config function similar to overseas-working-visitors after
// we figure out how to get the process variable
import {addYears, subYears} from 'date-fns';
import {format} from 'date-fns-tz';

const currentDateString = format(new Date(), 'yyyy-MM-dd', {timeZone: 'Australia/Sydney'});

export const defaultPricingParams = {
  dob: format(subYears(new Date(), 20), 'yyyy-MM-dd'),
  dateJoinedFund: currentDateString,
  effectiveDate: currentDateString,
  startDate: currentDateString,
  endDate: format(addYears(new Date(), 1), 'yyyy-MM-dd'),
  gender: 'Male',
  paymentFrequency: 'Weekly',
  scale: 'Single',
  hospitalProduct: 181,
  excess: '500'
};
